import React from "react";
import "./home.scss";
import Logo from "../../images/logotrimap-short.png";
import Aviso from "../../images/aviso_eleicoes_2026.png";
import WarningSign from "../../components/warningSign/index";

export default (props) => {

  return (
    <React.Fragment>
      <div className={"content-block dx-card responsive-paddings"}>
        <WarningSign message="O ID do CPBS não pode ser vazio!" visible={false} />
        <div className={"main-div-home"}>
          <img src={Aviso} alt="Aviso importante" width={"100%"} style={{maxWidth: "650px"}}  />
          <div className="div-contatos" style={{ minWidth: 800 }}>
            <ul>
              <li>Central de Suporte Trimap - (85) 4042-3189 - WhatsApp</li>
            </ul>
          </div>
        </div>
      </div>
      {/* <Dashboard /> */}
    </React.Fragment >
  );
}
